import * as React from 'react';

export interface ElementProps extends React.HTMLProps<HTMLElement> {
  component?: keyof React.ReactHTML;
}

export const TAB = 9;
export const UP = 38;
export const DOWN = 40;
export const ENTER = 13;

const Element = ({ component, ...otherProps }: ElementProps) =>
  React.createElement(component || 'div', otherProps);

// https://www.w3.org/TR/wai-aria-1.1/#role_definitions
type UsablilityRole =
  | 'button'
  | 'link'
  | 'checkbox'
  | 'radio'
  | 'select'
  | 'option'
  | 'listitem';

export interface ActionableProps extends ElementProps {
  onClick?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  role: UsablilityRole;
  ariaLabel: string;
}

const Actionable: React.FC<ActionableProps> = ({
  component,
  role,
  tabIndex,
  ariaLabel,
  className,
  onClick,
  onKeyDown,
  ...otherProps
}) => (
  <Element
    component={component}
    role={role}
    tabIndex={tabIndex || 0}
    aria-label={ariaLabel}
    className={className}
    onClick={onClick}
    onKeyDown={onKeyDown}
    {...otherProps}
  />
);

export default Actionable;
